




















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class VxInputGroup extends Vue {
  @Prop({ type: String })
  readonly prependClasses!: string

  @Prop({ type: String })
  readonly appendClasses!: string

  // Functional options
  data!: Record<string, any>
  props!: Record<string, any>
  slots!: () => any
}

